import { ProductWithSponsoredData } from '@/sellerAdsManagement/SponsoredProducts/interfaces/SponsoredProducts';

export const INIT_TOP_SPONSORED_PRODUCT_BANNER =
  'productDiscovery/INIT_TOP_SPONSORED_PRODUCT_BANNER';
export const FETCH_TOP_SPONSORED_PRODUCT_SUCCESS =
  'productDiscovery/FETCH_TOP_SPONSORED_PRODUCT_SUCCESS';
export const FETCH_TOP_SPONSORED_PRODUCT_NO_DATA =
  'productDiscovery/FETCH_TOP_SPONSORED_PRODUCT_NO_DATA';

export interface InitTopSponsoredProductBanner {
  type: typeof INIT_TOP_SPONSORED_PRODUCT_BANNER;
  modelId: number;
  device: string;
}

export const initTopSponsoredProductBanner = (
  modelId: number,
  device: string,
): InitTopSponsoredProductBanner => ({
  type: INIT_TOP_SPONSORED_PRODUCT_BANNER,
  modelId,
  device,
});

export interface FetchSponsoredProductSuccess {
  type: typeof FETCH_TOP_SPONSORED_PRODUCT_SUCCESS;
  sponsoredProduct: ProductWithSponsoredData;
}

export const fetchSponsoredProductSuccess = (
  sponsoredProduct: ProductWithSponsoredData,
): FetchSponsoredProductSuccess => ({
  type: FETCH_TOP_SPONSORED_PRODUCT_SUCCESS,
  sponsoredProduct,
});

export interface FetchSponsoredProductNoData {
  type: typeof FETCH_TOP_SPONSORED_PRODUCT_NO_DATA;
}

export type Action =
  | InitTopSponsoredProductBanner
  | FetchSponsoredProductSuccess
  | FetchSponsoredProductNoData;
